// Code generated from backend/api/*/openapi.yaml by scripts/gen-policy.mjs.
// DO NOT EDIT. Run `npm run generate:api` to regenerate.
//
// Maps each operationId to the Cognito groups allowed to call it (any-of).
// Operations absent here require only authentication (no specific group).

export const routePolicy: Record<string, string[]> = {
  bookClass: ["role_user"],
  cancelBooking: ["role_user", "role_instructor"],
  cancelClass: ["role_instructor"],
  createClass: ["role_instructor"],
  createPassType: ["role_instructor"],
  deleteMyPass: ["role_user"],
  deletePassType: ["role_instructor"],
  forceDeleteBooking: ["role_admin"],
  forceDeleteClass: ["role_admin"],
  forceDeletePassType: ["role_admin"],
  getClassRoster: ["role_instructor"],
  getMyPass: ["role_user"],
  getUser: ["role_instructor"],
  grantPass: ["role_instructor"],
  listBookings: ["role_user"],
  listUsers: ["role_instructor"],
  updateClass: ["role_instructor"],
  updatePassType: ["role_instructor"],
};
